import { Label } from "@/components/ui/label";

export const F = ({ label, children, hint }) => (
  <div className="mb-3">
    <Label className="text-xs uppercase tracking-wider">{label}</Label>
    <div className="mt-1.5">{children}</div>
    {hint && <p className="text-xs text-muted-foreground mt-1">{hint}</p>}
  </div>
);
